import './VehicleIncidents.scss';
import { reactPlugin } from '../../../../services/appInsights.service';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { TesterService } from '../../../../services/tester.service';
import { useEffect, useState } from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';
import { VehicleIncidentsViewModel } from '../../../../interfaces/tester.interface';
import { ComponentModelPopup } from '../../../../interfaces/modal.interface';
import { getFormattedLongDate } from '../../../../helpers/Utilities';
import Spinner from '../../../components/Spinner';
import ErrorComponentModel from '../../appUtilityComponent/ErrorComponentModel/ErrorComponentModel';

type TParams = { vehicleId: number, onClose: any, selectedIncidentId: number };

function VehicleIncidents({ vehicleId, onClose, selectedIncidentId }: TParams) {

    let [vehicleIncidents, setVehicleIncidents] = useState([] as VehicleIncidentsViewModel[]);

    let [isShowLoading, setIsShowLoading] = useState(false as boolean);

    let [errorModal, setErrorModal] = useState({
        Title: "Error",
        Show: false,
        Component: null,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
    } as ComponentModelPopup);

    let testerService = new TesterService();

    useEffect(() => {
        setIsShowLoading(true);
        testerService.GetIncidentsByVehicleId(vehicleId).then(res => {
            if (res.statusCode === "N") {
                const errorMessage = res.statusMessage || "Failed to fetch incidents";
                console.error("GetIncidentsByVehicleId error:", errorMessage);
                setErrorModal({
                    Title: "Error",
                    Show: true,
                    Component: <div>{errorMessage}</div>,
                    HandleClose: () => setErrorModal({ ...errorModal, Show: false })
                });
                setIsShowLoading(false);
                return;
            }
            setVehicleIncidents(res.result || []);
            setIsShowLoading(false);
        }).catch((error: any) => {
            const message = error?.statusMessage || error?.message || "An unexpected error occurred while fetching incidents";
            console.error("GetIncidentsByVehicleId exception:", error);
            setErrorModal({
                Title: "Error",
                Show: true,
                Component: <div>{message}</div>,
                HandleClose: () => setErrorModal({ ...errorModal, Show: false })
            });
            setIsShowLoading(false);
        });
    }, [vehicleId]);

    const OpenGoogleMaps = (incident: VehicleIncidentsViewModel) => {
        window.open("https://www.google.com/maps/search/?api=1&query=" + incident.latitude + "," + incident.longitude, '_blank');
    }

    return (
        <>
            <ErrorComponentModel modal={errorModal} />
            {vehicleIncidents.length > 0 &&

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Incident Date / Time</th>
                            <th>Latitude</th>
                            <th>Longitude</th>
                            <th>Comments</th>
                            <th>Status Code</th>
                            <th>Last Updated By</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vehicleIncidents.map(x =>
                            <tr key={x.incidentId} className={(x.incidentId === selectedIncidentId) ? "selected-incident" : ""}>
                                <td>{getFormattedLongDate(new Date(x.incidentDate))}</td>
                                <td>{x.latitude}</td>
                                <td>{x.longitude}</td>
                                <td>{x.comment}</td>
                                <td>{x.statusCode}</td>
                                <td>{x.updatedBy}</td>
                                <td>
                                    <Button variant="light" className="btn-default btn-save mr-2" onClick={() => { OpenGoogleMaps(x) }}>VIEW</Button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            }
            <Row>
                <Col className="text-left mt-2">
                    <Button className="ml-2 shadow-sm cursor-shadow btn-default btn-cancel" variant="light" onClick={onClose}>Close</Button>
                </Col>
            </Row>
            {isShowLoading && <Spinner></Spinner>}
        </>
    )
}

export default withAITracking(reactPlugin, VehicleIncidents);